import { IGioHocRangBuoc } from "../../model/respone/category/IGioHocRangBuoc";
import { apiClient } from "../apiClient";

export const GIO_HOC_RANG_BUOC_API = "gio-hoc-rang-buoc";
export const gioHocRangBuocApi = {
  SelectAll: () => apiClient.get(`${GIO_HOC_RANG_BUOC_API}`),
  Insert: (payload: IGioHocRangBuoc) => apiClient.post(`${GIO_HOC_RANG_BUOC_API}`, payload),
  Update: (payload: IGioHocRangBuoc) => apiClient.put(`${GIO_HOC_RANG_BUOC_API}`, payload),
  Delete: (id: number) => apiClient.delete(`${GIO_HOC_RANG_BUOC_API}/${id}`),
};
